<template>
  <div class="input-row">
    <div class="label">{{ label }}</div>
    <v-slider
      thumb-label
      dense
      :min="min || '0'"
      :max="max || '100'"
      :value="sliderValue"
      class="mt-2"
      @change="$emit('change', $event)"
    ></v-slider>
  </div>
</template>

<script>
export default {
  props: ["sliderValue", "label", "min", "max"],
};
</script>

<style scoped>
.input-row {
  display: flex;
  height: 40px;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
}

.label {
  font-size: 14px;
  width: 120px;
}
</style>